import React from 'react';
import { useAuth } from '@/AuthProvider';
import { Card, CardContent } from '@/components/ui/card';
import { motion } from 'framer-motion';
import ArticlesSection from '@/components/sections/articles-section';

export default function Dashboard() {
  const { user } = useAuth();
  const firstName = user?.user_metadata?.first_name || 'utilisateur';

  const tools = [
    {
      title: "Générer une offre",
      description: "Créez une offre percutante avec l’IA de PimpMyJob.",
      emoji: "📝",
      color: "bg-orange-100",
      url: "https://pimpmyjob.fr",
      external: true,
    },
    {
      title: "Mapping RH",
      description: "Préparez une cartographie claire de vos équipes RH.",
      emoji: "🗺️",
      color: "bg-blue-100",
      url: "/ressources/mapping-rh",
      external: false,
    },
    {
      title: "Onboarder mes équipes",
      description: "Accélérez l’intégration grâce à notre plateforme dédiée.",
      emoji: "🚀",
      color: "bg-pink-100",
      url: "https://loocatme.fr",
      external: true,
    },
    {
      title: "Mon assistant RH",
      description: "Optimisez vos processus RH avec l’IA Recruteurs.io.",
      emoji: "🤖",
      color: "bg-green-100",
      url: "/candidat/talentai",
      external: false,
    },
  ];

  return (
    <div className="space-y-10">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl p-8 shadow-lg"
      >
        <h1 className="text-3xl font-bold mb-2 text-neutral-900">
          👋 Bienvenue,{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
            {firstName.toLowerCase()}
          </span>
        </h1>
        <p className="text-neutral-600 text-lg">
          Retrouvez ici tous vos outils RH.
        </p>
      </motion.div>

      {/* Cartes outils RH */}
      <section className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {tools.map((tool, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Card
              className={`h-full min-h-[200px] transition-all duration-300 border border-transparent rounded-xl ${tool.color} cursor-pointer`}
              onClick={() =>
                tool.external
                  ? window.open(tool.url, "_blank")
                  : (window.location.href = tool.url)
              }
            >
              <CardContent className="p-6 h-full flex flex-col justify-between">
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-3xl">{tool.emoji}</span>
                  <h3 className="text-xl font-bold text-[#1f2937]">{tool.title}</h3>
                </div>
                <p className="text-neutral-700 mb-2">{tool.description}</p>
                <p className="text-sm text-green-700 font-medium">✅ Inclus pour nos clients recruteurs.io</p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </section>

      {/* Section articles dynamiques */}
      <ArticlesSection />
    </div>
  );
}